import React from 'react';

interface DropzoneContentProps {
  title: string;
}

const DropzoneContent: React.FC<DropzoneContentProps> = ({ title }) => (
  <div>
    <h5 className="mb-3 fw-bold text-primary">{title}</h5>
    <small className="text-muted d-block">Supported formats: WebP (max 50MB), MP4 (max 50MB)</small>
    <p className="mt-2">
      <span className="badge bg-info">Tip: Drop all image/video sizes at once!</span>
    </p>
  </div>
);

export default DropzoneContent;
